import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginAuthService {
   private baseUrl = environment.apiEndpoint + 'Master/LoginVendor';
  //private baseUrl = 'https://uat.rspl.net.in/CabBooking/api/Master/LoginVendor';
  //private baseUrl = 'https://intranet.rspl.net.in/CabBooking/api/Master/LoginVendor';

  constructor(private http: HttpClient) {}

  login(email: string, password: string): Observable<any> {
    const url = `${this.baseUrl}/${email}/${password}`;
    return this.http.get<any>(url);
  }
}



// import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { Observable } from 'rxjs';

// @Injectable({
//   providedIn: 'root'
// })
// export class LoginAuthService {
//   private apiUrl = 'https://uat.rspl.net.in/CabBooking/api/Master/LoginVendor/'; // Replace with your backend API

//   constructor(private http: HttpClient) {}

//   login(email: string, password: string, credentials: { email: string; password: string; }): Observable<any> {
//     //debugger
//     return this.http.post<any>(this.apiUrl, credentials);
//   }
// }





// import { Injectable, OnInit } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { map } from 'rxjs/operators';
// import { JwtHelperService } from '@auth0/angular-jwt';
// //import { environment } from 'src/environments/environment';
// import { BehaviorSubject } from 'rxjs';
// import { environment } from "../../environments/environment"

// @Injectable({
//   providedIn: 'root'
// })

// export class LoginAuthService {
//     baseUrl = environment.apiEndpoint + 'auth/';
//       jwtHelper = new JwtHelperService();
//       decodedToken: any;
//       //  currentUser: User;
//       photoUrl = new BehaviorSubject<string>('./assets/user.png');
//       currentPhotoUrl = this.photoUrl.asObservable();
    
//       constructor(private http: HttpClient) { }
//       loggedIn(): boolean {
//         const token = localStorage.getItem('token');
//         return !this.jwtHelper.isTokenExpired(token??'');
//       }
// }